import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getBlogs } from '../actions/MainAction';
export class NewsPage extends Component {
  openModal=(data)=>{
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        type: this.props.type,
        image_full_url: data?.image_full_url?data?.image_full_url:"",
       
        languages:
          {}
        ,
        requiredsLang: [],
        requireds:["image"],
        afterCallFunction:this.props.getBlogs,
        afterParams:[this.props.type],
        url:'admin-award'
      }
    })
  }

  componentDidMount(){
    this.props.getBlogs(this.props.type)
  }
  componentDidUpdate(prevProps, prevState){
    if(prevProps?.type != this.props.type){
        this.props.getBlogs(this.props.type)
    }
  }
  render() {
    const {blogs} = this.props;
    // console.log(blogs)
    return (
      <div className='p-[40px] w-full'>
        <Header  onClickBtn={this.openModal.bind(this, "", "", 1)} title={this.props.type === "certificate"?"Sertifikatlar": this.props.type === "thankyouletter"?"Təşəkkürnamələr":this.props.type === "lisence"? "Lisenziya":"Akkreditasiya"} />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
        {
            blogs?.map((data, i)=>{
              return(
                <Card1 
                  key={i}
                  image={data?.image_full_url}
                  onChangeLang={(id)=>this.openModal(data)}
                  title1={data?.translate?.title}
                  deleteUrl={`admin-award/${data?.id}`}
                  afterCallFunction={()=> this.props.getBlogs(this.props.type)}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  blogs: state.Data.blogs
});
const mapDispatchToProps = {changeStateValue, getBlogs}
export default connect(mapStateToProps, mapDispatchToProps)(NewsPage)